// Simple event system for dashboard updates
class DashboardEventEmitter {
  constructor() {
    this.listeners = {
      'course-purchased': [],
      'stats-updated': [],
      'enrollment-added': []
    };
  }

  on(event, callback) {
    if (this.listeners[event]) {
      this.listeners[event].push(callback);
    }
  }

  off(event, callback) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    }
  }

  emit(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(callback => {
        try {
          callback(data);
        } catch (error) {
          console.error('Dashboard event callback error:', error);
        }
      });
    }
  }
}

// Create a global instance
const dashboardEvents = new DashboardEventEmitter();

export default dashboardEvents; 